import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useMemo, useCallback } from 'react';
import { isDefined } from '@togglecorp/fujs';
import DateRangeInput from '../DateRangeInput/index.js';
import { genericMemo } from '../../utils/index.js';

function DateRangeDualInput(props) {
  const {
    fromName,
    toName,
    fromValue,
    toValue,
    fromOnChange,
    toOnChange,
    fromError,
    toError,
    ...otherProps
  } = props;
  const value = useMemo(() => fromValue && toValue ? {
    startDate: fromValue,
    endDate: toValue
  } : undefined, [toValue, fromValue]);
  const handleValueChange = useCallback(newVal => {
    if (fromOnChange) {
      fromOnChange(newVal === null || newVal === void 0 ? void 0 : newVal.startDate, fromName);
    }

    if (toOnChange) {
      toOnChange(newVal === null || newVal === void 0 ? void 0 : newVal.endDate, toName);
    }
  }, [toOnChange, fromOnChange, toName, fromName]);
  const error = useMemo(() => {
    const errors = [toError, fromError].filter(isDefined);
    return errors.length > 0 ? errors.join(', ') : undefined;
  }, [toError, fromError]);
  return /*#__PURE__*/React.createElement(DateRangeInput, _extends({
    name: undefined,
    value: value,
    onChange: handleValueChange,
    error: error
  }, otherProps));
}

var index = genericMemo(DateRangeDualInput);

export { index as default };
//# sourceMappingURL=index.js.map
